import { render, staticRenderFns } from "./DxWebpart.vue?vue&type=template&id=51c639c3"
import script from "./DxWebpart.ts?vue&type=script&lang=ts&external"
export * from "./DxWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports